export default {"src":"/_next/static/media/tortilla.1bb75644.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};